"use client";

import React from "react";
import { Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const benefits = [{
  title: "Advanced Soil Analysis",
  description: "Our state-of-the-art equipment ensures millimeter-accurate readings for all your geological surveying needs, providing data you can trust."
}, {
  title: "Precision Engineering",
  description: "We understand that accuracy is paramount. Our streamlined processes deliver comprehensive, high-fidelity reports faster than industry standards."
}, {
  title: "Sustainable Practices",
  description: "We employ eco-friendly methodologies to minimize environmental impact while maximizing data yield across all terrain types."
}, {
  title: "Expert Consultation",
  description: "Our team of seasoned geologists and engineers brings decades of combined experience to every project, ensuring optimal outcomes."
}];
export default function WhyChooseUs() {
  const {
    ref: sectionRef,
    isVisible: isSectionVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: contentRef,
    isVisible: isContentVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section id="why-choose-us" ref={sectionRef} className={`py-24 bg-foreground text-background transition-opacity duration-1000 ${isSectionVisible ? 'opacity-100' : 'opacity-0'}`}>
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          
          {}
          <div ref={imageRef} className={`relative w-full aspect-square lg:aspect-[4/5] transition-all duration-1000 delay-300 transform ${isImageVisible ? 'translate-x-0 opacity-100' : '-translate-x-12 opacity-0'}`}>
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569221/img/soil_strata_high_contrast.png" alt="High contrast soil strata analysis" className="object-cover w-full h-full rounded-none grayscale contrast-150 brightness-90" />
            {}
            <div className="absolute inset-0 border-2 border-background/10 pointer-events-none m-4"></div>
          </div>

          {}
          <div ref={contentRef} className={`flex flex-col justify-center transition-all duration-1000 delay-500 transform ${isContentVisible ? 'translate-x-0 opacity-100' : 'translate-x-12 opacity-0'}`}>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-sans uppercase tracking-widest mb-12 text-background">
              Why Choose Us
            </h2>

            <ul className="space-y-8">
              {benefits.map((benefit, i) => <li key={i} data-index={i} className="flex items-start gap-5 group">
                  <div className="mt-1 bg-primary/10 p-1 rounded-none">
                    <Check className="size-6 text-primary shrink-0" strokeWidth={3} />
                  </div>
                  <div>
                    <h3 className="text-xl font-bold font-sans uppercase tracking-wider text-background mb-2 group-hover:text-primary transition-colors duration-300">
                      {benefit.title}
                    </h3>
                    <p className="text-background/70 leading-relaxed font-sans">
                      {benefit.description}
                    </p>
                  </div>
                </li>)}
            </ul>

            <div className="mt-12 pt-8 border-t border-background/10">
              <Button variant="default" size="lg" className="rounded-none uppercase tracking-widest font-bold px-8 py-6 bg-primary text-primary-foreground hover:bg-primary/90 transition-all">
                Initiate Project
              </Button>
            </div>
          </div>

        </div>
      </div>
    </section>;
}